import { useState } from "react";
import type { CurrentUser } from "@soi/contracts";
import { ApiFailure, api } from "../lib/api.js";

export function LoginDialog({
  onClose,
  onSuccess,
}: {
  onClose: () => void;
  onSuccess: (user: CurrentUser) => void;
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !password) {
      setError("Merci de renseigner l'adresse e-mail et le mot de passe.");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      onSuccess(await api.login({ email: email.trim(), password }));
    } catch (err) {
      setError(
        err instanceof ApiFailure && err.code === "TROP_DE_TENTATIVES"
          ? err.message
          : // Deliberately identical for an unknown address and a wrong
            // password, matching the server, so the pair cannot be told apart.
            "Adresse e-mail ou mot de passe incorrect.",
      );
      setBusy(false);
    }
  };

  return (
    <div className="ovl" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="admin-modal-title">
        <div className="modal-head">
          <button type="button" className="modal-close" aria-label="Fermer" onClick={onClose}>
            ✕
          </button>
          <h2 id="admin-modal-title">Accès gestion</h2>
          <p>Réservé au Service d'organisation et d'informatique</p>
        </div>
        <form onSubmit={submit} noValidate>
          <div className="modal-body">
            <div className="field">
              <label htmlFor="admin-email">
                Adresse e-mail <span className="req">*</span>
              </label>
              <input
                type="email"
                id="admin-email"
                autoComplete="email"
                placeholder="prenom.nom@lausanne.ch"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="field">
              <label htmlFor="admin-password">
                Mot de passe <span className="req">*</span>
              </label>
              <input
                type="password"
                id="admin-password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
          {error && (
            <p className="modal-status err" role="alert">
              {error}
            </p>
          )}
          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-submit" disabled={busy}>
              {busy ? "Connexion…" : "Se connecter"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
